import { MedicationInstructionPayload } from '@/api/medicationInstruction/types'
import { DateString } from '@/types/utils'
import dayjs from 'dayjs'

export const createNewMedicationInstructionPayload = (
  today = dayjs()
): MedicationInstructionPayload => ({
  visitDate: today.format('YYYY-MM-DD') as DateString,
  doctorLastName: null,
  doctorFirstName: null,
  doctorDepartment: null,
  doctorPhoneNumber: null,
  doctorFaxNumber: null,
  caremanLastName: null,
  caremanFirstName: null,
  caremanDepartment: null,
  caremanPhoneNumber: null,
  caremanFaxNumber: null,
  supportLevel: null,
  careLevel: null,
  objective: null,
  todo: null,
  medicineCustodian: null,
  medicineReqGenelic: null,
  medicineStorageMethod: null,
  medicineStorageMethodFree: null,
  instructionTarget: null,
  instructionEfficacyDescription: null,
  instructionUnderstanding: null,
  instructionStorageStatus: null,
  instructionEffective: null,
  instructionAnotherDepartment: null,
  instructionSideEffect: null,
  instructionHealthPreference: null,
  instructionChiefComplaint: null,
  instructionContent: null,
  instructionConcurrentMedication: null,
  nextVisitDate: today.add(1, 'day').format('YYYY-MM-DD') as DateString,
  handover: null,
  eatingAppetite: null,
  eatingMealCount: null,
  eatingMealAmount: null,
  eatingDysphagia: null,
  excretionDaytimeUrinationCount: null,
  excretionNighttimeUrinationCount: null,
  excretionBowelMovement: null,
  excretionSweating: null,
  sleepDaytime: null,
  sleepDaytimeHours: null,
  sleepNighttime: null,
  motorWeakFeeling: null,
  motorStagger: null,
  motorFalling: null,
  influenceMedication: null,
  dementiaEtcNote: null
})
